/**
 * Shelves
 */
export default class Shelves {

	constructor() {

		this.shelves   = document.querySelectorAll( ".shelf" );
		this.menuItems = document.querySelectorAll( ".js--shelf-navigation .menu-item" );

		this.addEventListeners();

	}

	/**
	 * Add an event listener for every menu item on the page and trigger
	 * the on hover callback when we hover over a menu item.
	 */
	addEventListeners() {
		this.menuItems.forEach( ( menuItem ) => {
			menuItem.addEventListener( "mouseover", () => {
				this.onMenuItemHover( event );
			} );
		} );

		document.querySelector( ".js--site-header" ).addEventListener( "mouseleave", () => {
			this.closeShelves();
		} );

	}

	/**
	 * Get the menu ID (number) from the element ID (string).
	 *
	 * @param menuItem
	 * @returns {*}
	 */
	getMenuId( menuItem ) {
		const parts = menuItem.id.split( "-" );
		return parts[ parts.length - 1 ];
	}

	/**
	 * Callback when the user hovers over a menu item.
	 * Provided we have a valid menu ID, we check if
	 * we are able to open a shelf.
	 *
	 * @param event
	 */
	onMenuItemHover( event ) {
		const menuItem = event.target;

		const menuId = this.getMenuId( menuItem );

		if ( menuId ) {

			const shelf = document.querySelector( "#shelf-" + menuId );

			if ( shelf ) {
				this.openShelf( shelf );
				menuItem.classList.add( "has-open-shelf" );
				document.body.classList.add( "has-open-menu-shelf" );
			} else {
				this.closeShelves();
			}

		} else {
			this.closeShelves();
		}

	}

	/**
	 * Open the shelf.
	 *
	 * @param shelf
	 */
	openShelf( shelf ) {

		// If we are changing to another menu item and have a shelf
		// currently open, close it first. Otherwise both stays open.
		if ( ! shelf.classList.contains( "is-open" ) ) {
			this.closeShelves();
		}

		shelf.classList.add( "is-open" );

	}

	/**
	 * Loop through and close all shelves on the page.
	 */
	closeShelves() {

		document.body.classList.remove( "has-open-menu-shelf" );

		this.shelves.forEach( ( shelf ) => {
			shelf.classList.remove( "is-open" );
		} );

		this.menuItems.forEach( ( menuItem ) => {
			menuItem.classList.remove( "has-open-shelf" );
		} );

	}

}
